import { render, staticRenderFns } from "./VotesPage.vue?vue&type=template&id=082dffc0&scoped=true&"
import script from "./VotesPage.vue?vue&type=script&lang=js&"
export * from "./VotesPage.vue?vue&type=script&lang=js&"
import style0 from "./VotesPage.vue?vue&type=style&index=0&id=082dffc0&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082dffc0",
  null
  
)

export default component.exports